module.exports = __webpack_public_path__ + "img/pic-03.83a97bba.png";